import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.core').factory('ModelContext', ModelContextData);

  /* @ngInject */
  function ModelContextData(logger) {
    ModelContext.prototype = {
      build: build,
    };

    function ModelContext(entity,type,showBackDoButton,paramKiss) {
      if (entity) {
        this.build(entity,type,showBackDoButton,paramKiss);
      } else {
        logger.error('Error with entity', entity);
      }
    }

    return ModelContext;

    function build(entity,type,showBackDoButton,paramKiss) {
      this.eid = entity.eid;
      this.id = entity.id;
      this.type = type;
      this.paramKiss = paramKiss;
      this.hasOrder = entity.orderEm || entity.orderRe;
      this.canActivateOrder = entity.profilBuyer && !entity.isConfigPortail() && paramKiss;
      this.showBackDoButton = showBackDoButton
    }

  }
})();
